// extracted by mini-css-extract-plugin
module.exports = {"textShadow":"TextStyles_textShadow__C7ODM"};